import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFinanceDepartment = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "#fff",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_8171",
		"data-name": "Path 8171",
		d: "M19,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3ZM13.56,6.53h0a.754.754,0,0,1,1.06,0l.88.88.88-.88a.754.754,0,0,1,1.06,0h0a.754.754,0,0,1,0,1.06l-.88.88.88.88a.754.754,0,0,1,0,1.06h0a.754.754,0,0,1-1.06,0l-.88-.87-.88.88a.754.754,0,0,1-1.06,0h0a.754.754,0,0,1,0-1.06l.88-.88-.88-.88A.749.749,0,0,1,13.56,6.53ZM7,7.72h3.5a.755.755,0,0,1,.75.75h0a.755.755,0,0,1-.75.75H7a.755.755,0,0,1-.75-.75h0A.755.755,0,0,1,7,7.72ZM10.75,16H9.5v1.25a.755.755,0,0,1-.75.75h0A.755.755,0,0,1,8,17.25V16H6.75A.755.755,0,0,1,6,15.25H6a.755.755,0,0,1,.75-.75H8V13.25a.755.755,0,0,1,.75-.75h0a.755.755,0,0,1,.75.75V14.5h1.25a.755.755,0,0,1,.75.75h0A.755.755,0,0,1,10.75,16Zm6.5,1.25h-3.5A.755.755,0,0,1,13,16.5h0a.755.755,0,0,1,.75-.75h3.5a.755.755,0,0,1,.75.75h0A.755.755,0,0,1,17.25,17.25Zm0-2.5h-3.5A.755.755,0,0,1,13,14h0a.755.755,0,0,1,.75-.75h3.5A.755.755,0,0,1,18,14h0A.755.755,0,0,1,17.25,14.75Z",
		transform: "translate(-3 -3)"
	})
});
export { SvgFinanceDepartment as ReactComponent };
